module.exports = __webpack_public_path__ + "static/img/icon-BUL.a61bc92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-BUL.svg
// module id = +P/d
// module chunks = 0